export default __webpack_public_path__ + "static/media/download_white.ee318178.svg";